import { render } from "./DesignButton.vue?vue&type=template&id=6cb44c82&scoped=true"
import script from "./DesignButton.vue?vue&type=script&lang=js"
export * from "./DesignButton.vue?vue&type=script&lang=js"

import "./DesignButton.vue?vue&type=style&index=0&id=6cb44c82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb44c82"]])

export default __exports__